export default class StorageService {
    public getAccessToken = () => {
        return localStorage.getItem("accessToken")
    }

    public getRefreshToken = () => {
        return localStorage.getItem("refreshToken")
    }

    public setAccessToken = (token) => {
        localStorage.setItem('accessToken', token);
    }

    public setRefreshToken = (token) => {
        localStorage.setItem('refreshToken', token);
    }

    public removeAccessToken = () => {
        localStorage.removeItem("accessToken")
    }

    public removeRefreshToken = () => {
        localStorage.removeItem("refreshToken")
    }

    public clearStorage = () => {
        localStorage.clear();
    }
}
